export enum NumbersEnum {
    fiveHundred = 500,
}